var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33341 8.43747C7.18282 8.43747 6.25008 9.34689 6.25008 10.4687C6.25008 11.5905 7.18282 12.5 8.33341 12.5C9.48401 12.5 10.4167 11.5905 10.4167 10.4687C10.4167 9.34689 9.48401 8.43747 8.33341 8.43747Z",
    fill: "#111D5E",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 8.43747C13.8495 8.43747 12.9167 9.34689 12.9167 10.4687C12.9167 11.5905 13.8495 12.5 15.0001 12.5C16.1507 12.5 17.0834 11.5905 17.0834 10.4687C17.0834 9.34689 16.1507 8.43747 15.0001 8.43747Z",
    fill: "#111D5E",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5834 10.4687C19.5834 9.34689 20.5162 8.43747 21.6667 8.43747C22.8173 8.43747 23.7501 9.34689 23.7501 10.4687C23.7501 11.5905 22.8173 12.5 21.6667 12.5C20.5162 12.5 19.5834 11.5905 19.5834 10.4687Z",
    fill: "#111D5E",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8346 0.463256C17.3443 0.0898964 12.8305 0.0682289 8.33665 0.398462L8.0146 0.422128C3.72909 0.73705 0.416748 4.21915 0.416748 8.40937V22.25C0.416748 22.6788 0.647858 23.076 1.02533 23.296C1.4028 23.5161 1.87109 23.5265 2.25848 23.3235L8.77646 19.9082C9.07965 19.7494 9.41848 19.6662 9.76268 19.6662H24.7234C26.6102 19.6662 28.2272 18.351 28.5654 16.5411C29.2508 12.8731 29.305 9.11941 28.7256 5.43406L28.5549 4.34803C28.244 2.37081 26.585 0.858241 24.5409 0.688272L21.8346 0.463256ZM8.52454 2.82907C12.8851 2.50863 17.2651 2.52965 21.6222 2.89194L24.3284 3.11696C25.2223 3.19128 25.9478 3.85272 26.0837 4.71735L26.2545 5.80338C26.7918 9.22121 26.7416 12.7024 26.1059 16.1042C25.9842 16.7554 25.4023 17.2287 24.7234 17.2287H9.76268C9.00545 17.2287 8.26001 17.4116 7.593 17.7611L2.91675 20.2114V8.40937C2.91675 5.49428 5.22111 3.07182 8.20249 2.85273L8.52454 2.82907Z",
    fill: "#111D5E",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatInactive);
export default __webpack_public_path__ + "static/media/Chat_Inactive.2bc10ca46c677fbada1b680124cf84c3.svg";
export { ForwardRef as ReactComponent };